import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=6ca76b7c&scoped=true&"
import script from "./JoinUs.vue?vue&type=script&lang=ts&"
export * from "./JoinUs.vue?vue&type=script&lang=ts&"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=6ca76b7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca76b7c",
  null
  
)

export default component.exports